import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { CategoryPlanDestination } from './types';

export async function getCategoryPlanDestinations(
  scope: RequestScope,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<{ destinations: CategoryPlanDestination[] }>> {
  try {
    const res = await scopedChannelApi(scope).get<{ destinations: CategoryPlanDestination[] }>('atts/category-plan/destinations', {
      ...options,
      headers: buildAsturHeaders(),
    });
    if (!Array.isArray(res.data?.destinations)) throw new Error('Invalid category plan destinations response');
    return { data: res.data, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
